import { MessagingApi } from "./messagingApi";

export class MessagingService {
	constructor(private readonly messagingService: MessagingApi) {}

	async createToken(): Promise<string> {
		const token = await this.messagingService.createToken();
		return token;
	}
}
